var cov_20tzfergng = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/index.tsx",
      hash = "5b486fe7299ab1dcda1b067abf601995d6a1182b",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 28
        },
        end: {
          line: 19,
          column: 81
        }
      },
      "1": {
        start: {
          line: 20,
          column: 22
        },
        end: {
          line: 20,
          column: 49
        }
      },
      "2": {
        start: {
          line: 21,
          column: 20
        },
        end: {
          line: 24,
          column: 8
        }
      },
      "3": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 16
        }
      },
      "4": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 49,
          column: 5
        }
      },
      "5": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 60
        }
      },
      "6": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 36
        }
      },
      "7": {
        start: {
          line: 56,
          column: 20
        },
        end: {
          line: 56,
          column: 44
        }
      },
      "8": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 49
        }
      },
      "9": {
        start: {
          line: 57,
          column: 33
        },
        end: {
          line: 57,
          column: 49
        }
      },
      "10": {
        start: {
          line: 58,
          column: 16
        },
        end: {
          line: 58,
          column: 74
        }
      },
      "11": {
        start: {
          line: 58,
          column: 36
        },
        end: {
          line: 58,
          column: 73
        }
      },
      "12": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 42
        }
      },
      "13": {
        start: {
          line: 59,
          column: 26
        },
        end: {
          line: 59,
          column: 42
        }
      },
      "14": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 33
        }
      },
      "15": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 66,
          column: 5
        }
      },
      "16": {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 65,
          column: 31
        }
      },
      "17": {
        start: {
          line: 68,
          column: 35
        },
        end: {
          line: 68,
          column: 45
        }
      },
      "18": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 56
        }
      },
      "19": {
        start: {
          line: 69,
          column: 34
        },
        end: {
          line: 69,
          column: 55
        }
      },
      "20": {
        start: {
          line: 71,
          column: 15
        },
        end: {
          line: 71,
          column: 17
        }
      },
      "21": {
        start: {
          line: 72,
          column: 16
        },
        end: {
          line: 72,
          column: 18
        }
      },
      "22": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 76,
          column: 6
        }
      },
      "23": {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 74,
          column: 38
        }
      },
      "24": {
        start: {
          line: 74,
          column: 30
        },
        end: {
          line: 74,
          column: 38
        }
      },
      "25": {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 75,
          column: 53
        }
      },
      "26": {
        start: {
          line: 75,
          column: 44
        },
        end: {
          line: 75,
          column: 53
        }
      },
      "27": {
        start: {
          line: 77,
          column: 26
        },
        end: {
          line: 77,
          column: 31
        }
      },
      "28": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 92,
          column: 5
        }
      },
      "29": {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 91,
          column: 8
        }
      },
      "30": {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 80,
          column: 23
        }
      },
      "31": {
        start: {
          line: 81,
          column: 8
        },
        end: {
          line: 81,
          column: 50
        }
      },
      "32": {
        start: {
          line: 81,
          column: 37
        },
        end: {
          line: 81,
          column: 50
        }
      },
      "33": {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 82,
          column: 43
        }
      },
      "34": {
        start: {
          line: 82,
          column: 23
        },
        end: {
          line: 82,
          column: 43
        }
      },
      "35": {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 83,
          column: 46
        }
      },
      "36": {
        start: {
          line: 83,
          column: 24
        },
        end: {
          line: 83,
          column: 46
        }
      },
      "37": {
        start: {
          line: 84,
          column: 8
        },
        end: {
          line: 84,
          column: 58
        }
      },
      "38": {
        start: {
          line: 84,
          column: 37
        },
        end: {
          line: 84,
          column: 58
        }
      },
      "39": {
        start: {
          line: 85,
          column: 8
        },
        end: {
          line: 85,
          column: 48
        }
      },
      "40": {
        start: {
          line: 85,
          column: 25
        },
        end: {
          line: 85,
          column: 48
        }
      },
      "41": {
        start: {
          line: 86,
          column: 8
        },
        end: {
          line: 89,
          column: 9
        }
      },
      "42": {
        start: {
          line: 87,
          column: 10
        },
        end: {
          line: 87,
          column: 78
        }
      },
      "43": {
        start: {
          line: 87,
          column: 53
        },
        end: {
          line: 87,
          column: 78
        }
      },
      "44": {
        start: {
          line: 88,
          column: 10
        },
        end: {
          line: 88,
          column: 56
        }
      },
      "45": {
        start: {
          line: 88,
          column: 34
        },
        end: {
          line: 88,
          column: 56
        }
      },
      "46": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 99,
          column: 5
        }
      },
      "47": {
        start: {
          line: 93,
          column: 37
        },
        end: {
          line: 93,
          column: 83
        }
      },
      "48": {
        start: {
          line: 94,
          column: 6
        },
        end: {
          line: 98,
          column: 7
        }
      },
      "49": {
        start: {
          line: 95,
          column: 8
        },
        end: {
          line: 97,
          column: 10
        }
      },
      "50": {
        start: {
          line: 96,
          column: 10
        },
        end: {
          line: 96,
          column: 95
        }
      },
      "51": {
        start: {
          line: 96,
          column: 70
        },
        end: {
          line: 96,
          column: 95
        }
      },
      "52": {
        start: {
          line: 101,
          column: 25
        },
        end: {
          line: 101,
          column: 65
        }
      },
      "53": {
        start: {
          line: 101,
          column: 43
        },
        end: {
          line: 101,
          column: 64
        }
      },
      "54": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 110,
          column: 5
        }
      },
      "55": {
        start: {
          line: 103,
          column: 6
        },
        end: {
          line: 109,
          column: 8
        }
      },
      "56": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 112,
          column: 29
        }
      },
      "57": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 114,
          column: 29
        }
      },
      "58": {
        start: {
          line: 118,
          column: 34
        },
        end: {
          line: 118,
          column: 44
        }
      },
      "59": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 126,
          column: 5
        }
      },
      "60": {
        start: {
          line: 120,
          column: 6
        },
        end: {
          line: 120,
          column: 113
        }
      },
      "61": {
        start: {
          line: 121,
          column: 6
        },
        end: {
          line: 125,
          column: 7
        }
      },
      "62": {
        start: {
          line: 121,
          column: 39
        },
        end: {
          line: 125,
          column: 7
        }
      },
      "63": {
        start: {
          line: 122,
          column: 19
        },
        end: {
          line: 122,
          column: 74
        }
      },
      "64": {
        start: {
          line: 123,
          column: 19
        },
        end: {
          line: 123,
          column: 74
        }
      },
      "65": {
        start: {
          line: 124,
          column: 8
        },
        end: {
          line: 124,
          column: 76
        }
      },
      "66": {
        start: {
          line: 127,
          column: 4
        },
        end: {
          line: 127,
          column: 22
        }
      },
      "67": {
        start: {
          line: 131,
          column: 24
        },
        end: {
          line: 131,
          column: 34
        }
      },
      "68": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 132,
          column: 32
        }
      },
      "69": {
        start: {
          line: 132,
          column: 18
        },
        end: {
          line: 132,
          column: 32
        }
      },
      "70": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 133,
          column: 91
        }
      },
      "71": {
        start: {
          line: 133,
          column: 31
        },
        end: {
          line: 133,
          column: 90
        }
      },
      "72": {
        start: {
          line: 137,
          column: 24
        },
        end: {
          line: 137,
          column: 34
        }
      },
      "73": {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 138,
          column: 34
        }
      },
      "74": {
        start: {
          line: 138,
          column: 18
        },
        end: {
          line: 138,
          column: 34
        }
      },
      "75": {
        start: {
          line: 139,
          column: 16
        },
        end: {
          line: 139,
          column: 91
        }
      },
      "76": {
        start: {
          line: 139,
          column: 34
        },
        end: {
          line: 139,
          column: 90
        }
      },
      "77": {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 140,
          column: 50
        }
      },
      "78": {
        start: {
          line: 140,
          column: 40
        },
        end: {
          line: 140,
          column: 50
        }
      },
      "79": {
        start: {
          line: 141,
          column: 4
        },
        end: {
          line: 141,
          column: 20
        }
      },
      "80": {
        start: {
          line: 151,
          column: 29
        },
        end: {
          line: 151,
          column: 39
        }
      },
      "81": {
        start: {
          line: 153,
          column: 4
        },
        end: {
          line: 174,
          column: 5
        }
      },
      "82": {
        start: {
          line: 154,
          column: 6
        },
        end: {
          line: 172,
          column: 7
        }
      },
      "83": {
        start: {
          line: 156,
          column: 23
        },
        end: {
          line: 156,
          column: 85
        }
      },
      "84": {
        start: {
          line: 156,
          column: 71
        },
        end: {
          line: 156,
          column: 84
        }
      },
      "85": {
        start: {
          line: 157,
          column: 10
        },
        end: {
          line: 161,
          column: 11
        }
      },
      "86": {
        start: {
          line: 158,
          column: 12
        },
        end: {
          line: 158,
          column: 34
        }
      },
      "87": {
        start: {
          line: 159,
          column: 12
        },
        end: {
          line: 159,
          column: 30
        }
      },
      "88": {
        start: {
          line: 160,
          column: 12
        },
        end: {
          line: 160,
          column: 31
        }
      },
      "89": {
        start: {
          line: 164,
          column: 22
        },
        end: {
          line: 166,
          column: 92
        }
      },
      "90": {
        start: {
          line: 165,
          column: 25
        },
        end: {
          line: 165,
          column: 46
        }
      },
      "91": {
        start: {
          line: 166,
          column: 23
        },
        end: {
          line: 166,
          column: 90
        }
      },
      "92": {
        start: {
          line: 167,
          column: 10
        },
        end: {
          line: 169,
          column: 11
        }
      },
      "93": {
        start: {
          line: 168,
          column: 12
        },
        end: {
          line: 168,
          column: 28
        }
      },
      "94": {
        start: {
          line: 170,
          column: 10
        },
        end: {
          line: 170,
          column: 71
        }
      },
      "95": {
        start: {
          line: 170,
          column: 28
        },
        end: {
          line: 170,
          column: 71
        }
      },
      "96": {
        start: {
          line: 173,
          column: 6
        },
        end: {
          line: 173,
          column: 12
        }
      },
      "97": {
        start: {
          line: 175,
          column: 4
        },
        end: {
          line: 255,
          column: 5
        }
      },
      "98": {
        start: {
          line: 176,
          column: 6
        },
        end: {
          line: 238,
          column: 7
        }
      },
      "99": {
        start: {
          line: 178,
          column: 45
        },
        end: {
          line: 184,
          column: 13
        }
      },
      "100": {
        start: {
          line: 178,
          column: 68
        },
        end: {
          line: 184,
          column: 11
        }
      },
      "101": {
        start: {
          line: 185,
          column: 23
        },
        end: {
          line: 185,
          column: 60
        }
      },
      "102": {
        start: {
          line: 185,
          column: 46
        },
        end: {
          line: 185,
          column: 59
        }
      },
      "103": {
        start: {
          line: 186,
          column: 10
        },
        end: {
          line: 189,
          column: 11
        }
      },
      "104": {
        start: {
          line: 187,
          column: 12
        },
        end: {
          line: 187,
          column: 29
        }
      },
      "105": {
        start: {
          line: 188,
          column: 12
        },
        end: {
          line: 188,
          column: 20
        }
      },
      "106": {
        start: {
          line: 190,
          column: 10
        },
        end: {
          line: 232,
          column: 11
        }
      },
      "107": {
        start: {
          line: 191,
          column: 12
        },
        end: {
          line: 191,
          column: 30
        }
      },
      "108": {
        start: {
          line: 192,
          column: 12
        },
        end: {
          line: 192,
          column: 32
        }
      },
      "109": {
        start: {
          line: 193,
          column: 12
        },
        end: {
          line: 193,
          column: 32
        }
      },
      "110": {
        start: {
          line: 194,
          column: 28
        },
        end: {
          line: 194,
          column: 57
        }
      },
      "111": {
        start: {
          line: 194,
          column: 42
        },
        end: {
          line: 194,
          column: 55
        }
      },
      "112": {
        start: {
          line: 195,
          column: 12
        },
        end: {
          line: 195,
          column: 33
        }
      },
      "113": {
        start: {
          line: 196,
          column: 12
        },
        end: {
          line: 196,
          column: 35
        }
      },
      "114": {
        start: {
          line: 197,
          column: 12
        },
        end: {
          line: 197,
          column: 56
        }
      },
      "115": {
        start: {
          line: 197,
          column: 34
        },
        end: {
          line: 197,
          column: 55
        }
      },
      "116": {
        start: {
          line: 198,
          column: 25
        },
        end: {
          line: 198,
          column: 117
        }
      },
      "117": {
        start: {
          line: 199,
          column: 12
        },
        end: {
          line: 199,
          column: 29
        }
      },
      "118": {
        start: {
          line: 201,
          column: 12
        },
        end: {
          line: 205,
          column: 13
        }
      },
      "119": {
        start: {
          line: 202,
          column: 14
        },
        end: {
          line: 202,
          column: 46
        }
      },
      "120": {
        start: {
          line: 203,
          column: 14
        },
        end: {
          line: 203,
          column: 85
        }
      },
      "121": {
        start: {
          line: 204,
          column: 14
        },
        end: {
          line: 204,
          column: 58
        }
      },
      "122": {
        start: {
          line: 204,
          column: 36
        },
        end: {
          line: 204,
          column: 57
        }
      },
      "123": {
        start: {
          line: 206,
          column: 12
        },
        end: {
          line: 216,
          column: 13
        }
      },
      "124": {
        start: {
          line: 207,
          column: 14
        },
        end: {
          line: 214,
          column: 16
        }
      },
      "125": {
        start: {
          line: 215,
          column: 14
        },
        end: {
          line: 215,
          column: 47
        }
      },
      "126": {
        start: {
          line: 217,
          column: 25
        },
        end: {
          line: 217,
          column: 117
        }
      },
      "127": {
        start: {
          line: 218,
          column: 12
        },
        end: {
          line: 226,
          column: 14
        }
      },
      "128": {
        start: {
          line: 227,
          column: 12
        },
        end: {
          line: 231,
          column: 14
        }
      },
      "129": {
        start: {
          line: 228,
          column: 25
        },
        end: {
          line: 228,
          column: 51
        }
      },
      "130": {
        start: {
          line: 229,
          column: 25
        },
        end: {
          line: 229,
          column: 51
        }
      },
      "131": {
        start: {
          line: 230,
          column: 14
        },
        end: {
          line: 230,
          column: 41
        }
      },
      "132": {
        start: {
          line: 233,
          column: 10
        },
        end: {
          line: 236,
          column: 11
        }
      },
      "133": {
        start: {
          line: 234,
          column: 12
        },
        end: {
          line: 234,
          column: 56
        }
      },
      "134": {
        start: {
          line: 234,
          column: 34
        },
        end: {
          line: 234,
          column: 55
        }
      },
      "135": {
        start: {
          line: 235,
          column: 12
        },
        end: {
          line: 235,
          column: 28
        }
      },
      "136": {
        start: {
          line: 241,
          column: 8
        },
        end: {
          line: 241,
          column: 115
        }
      },
      "137": {
        start: {
          line: 242,
          column: 6
        },
        end: {
          line: 254,
          column: 7
        }
      },
      "138": {
        start: {
          line: 244,
          column: 10
        },
        end: {
          line: 244,
          column: 27
        }
      },
      "139": {
        start: {
          line: 245,
          column: 10
        },
        end: {
          line: 252,
          column: 12
        }
      },
      "140": {
        start: {
          line: 259,
          column: 38
        },
        end: {
          line: 259,
          column: 48
        }
      },
      "141": {
        start: {
          line: 260,
          column: 20
        },
        end: {
          line: 260,
          column: 44
        }
      },
      "142": {
        start: {
          line: 261,
          column: 23
        },
        end: {
          line: 261,
          column: 33
        }
      },
      "143": {
        start: {
          line: 262,
          column: 4
        },
        end: {
          line: 262,
          column: 89
        }
      },
      "144": {
        start: {
          line: 262,
          column: 18
        },
        end: {
          line: 262,
          column: 89
        }
      },
      "145": {
        start: {
          line: 264,
          column: 19
        },
        end: {
          line: 264,
          column: 29
        }
      },
      "146": {
        start: {
          line: 265,
          column: 4
        },
        end: {
          line: 269,
          column: 8
        }
      },
      "147": {
        start: {
          line: 266,
          column: 19
        },
        end: {
          line: 266,
          column: 29
        }
      },
      "148": {
        start: {
          line: 268,
          column: 8
        },
        end: {
          line: 268,
          column: 82
        }
      },
      "149": {
        start: {
          line: 268,
          column: 20
        },
        end: {
          line: 268,
          column: 82
        }
      },
      "150": {
        start: {
          line: 268,
          column: 62
        },
        end: {
          line: 268,
          column: 81
        }
      },
      "151": {
        start: {
          line: 271,
          column: 28
        },
        end: {
          line: 271,
          column: 53
        }
      },
      "152": {
        start: {
          line: 272,
          column: 25
        },
        end: {
          line: 272,
          column: 30
        }
      },
      "153": {
        start: {
          line: 273,
          column: 4
        },
        end: {
          line: 279,
          column: 5
        }
      },
      "154": {
        start: {
          line: 274,
          column: 6
        },
        end: {
          line: 274,
          column: 29
        }
      },
      "155": {
        start: {
          line: 275,
          column: 11
        },
        end: {
          line: 279,
          column: 5
        }
      },
      "156": {
        start: {
          line: 276,
          column: 6
        },
        end: {
          line: 276,
          column: 37
        }
      },
      "157": {
        start: {
          line: 277,
          column: 11
        },
        end: {
          line: 279,
          column: 5
        }
      },
      "158": {
        start: {
          line: 278,
          column: 6
        },
        end: {
          line: 278,
          column: 31
        }
      },
      "159": {
        start: {
          line: 281,
          column: 33
        },
        end: {
          line: 284,
          column: 29
        }
      },
      "160": {
        start: {
          line: 285,
          column: 34
        },
        end: {
          line: 285,
          column: 77
        }
      },
      "161": {
        start: {
          line: 287,
          column: 24
        },
        end: {
          line: 287,
          column: 86
        }
      },
      "162": {
        start: {
          line: 289,
          column: 4
        },
        end: {
          line: 301,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        },
        loc: {
          start: {
            line: 45,
            column: 55
          },
          end: {
            line: 53,
            column: 3
          }
        },
        line: 45
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 55,
            column: 2
          },
          end: {
            line: 55,
            column: 3
          }
        },
        loc: {
          start: {
            line: 55,
            column: 23
          },
          end: {
            line: 61,
            column: 3
          }
        },
        line: 55
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 58,
            column: 31
          },
          end: {
            line: 58,
            column: 32
          }
        },
        loc: {
          start: {
            line: 58,
            column: 36
          },
          end: {
            line: 58,
            column: 73
          }
        },
        line: 58
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 63,
            column: 2
          },
          end: {
            line: 63,
            column: 3
          }
        },
        loc: {
          start: {
            line: 63,
            column: 72
          },
          end: {
            line: 115,
            column: 3
          }
        },
        line: 63
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 69,
            column: 29
          },
          end: {
            line: 69,
            column: 30
          }
        },
        loc: {
          start: {
            line: 69,
            column: 34
          },
          end: {
            line: 69,
            column: 55
          }
        },
        line: 69
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 73,
            column: 20
          },
          end: {
            line: 73,
            column: 21
          }
        },
        loc: {
          start: {
            line: 73,
            column: 30
          },
          end: {
            line: 76,
            column: 5
          }
        },
        line: 73
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 78,
            column: 74
          },
          end: {
            line: 78,
            column: 75
          }
        },
        loc: {
          start: {
            line: 79,
            column: 6
          },
          end: {
            line: 91,
            column: 8
          }
        },
        line: 79
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 79,
            column: 15
          },
          end: {
            line: 79,
            column: 16
          }
        },
        loc: {
          start: {
            line: 79,
            column: 24
          },
          end: {
            line: 91,
            column: 7
          }
        },
        line: 79
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 93,
            column: 32
          },
          end: {
            line: 93,
            column: 33
          }
        },
        loc: {
          start: {
            line: 93,
            column: 37
          },
          end: {
            line: 93,
            column: 83
          }
        },
        line: 93
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 94,
            column: 50
          },
          end: {
            line: 94,
            column: 51
          }
        },
        loc: {
          start: {
            line: 95,
            column: 8
          },
          end: {
            line: 97,
            column: 10
          }
        },
        line: 95
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 95,
            column: 17
          },
          end: {
            line: 95,
            column: 18
          }
        },
        loc: {
          start: {
            line: 95,
            column: 26
          },
          end: {
            line: 97,
            column: 9
          }
        },
        line: 95
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 101,
            column: 38
          },
          end: {
            line: 101,
            column: 39
          }
        },
        loc: {
          start: {
            line: 101,
            column: 43
          },
          end: {
            line: 101,
            column: 64
          }
        },
        line: 101
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 117,
            column: 2
          },
          end: {
            line: 117,
            column: 3
          }
        },
        loc: {
          start: {
            line: 117,
            column: 19
          },
          end: {
            line: 128,
            column: 3
          }
        },
        line: 117
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 121,
            column: 20
          },
          end: {
            line: 121,
            column: 21
          }
        },
        loc: {
          start: {
            line: 121,
            column: 39
          },
          end: {
            line: 125,
            column: 7
          }
        },
        line: 121
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 121,
            column: 39
          },
          end: {
            line: 121,
            column: 40
          }
        },
        loc: {
          start: {
            line: 121,
            column: 49
          },
          end: {
            line: 125,
            column: 7
          }
        },
        line: 121
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 130,
            column: 2
          },
          end: {
            line: 130,
            column: 3
          }
        },
        loc: {
          start: {
            line: 130,
            column: 22
          },
          end: {
            line: 134,
            column: 3
          }
        },
        line: 130
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 133,
            column: 26
          },
          end: {
            line: 133,
            column: 27
          }
        },
        loc: {
          start: {
            line: 133,
            column: 31
          },
          end: {
            line: 133,
            column: 90
          }
        },
        line: 133
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 136,
            column: 2
          },
          end: {
            line: 136,
            column: 3
          }
        },
        loc: {
          start: {
            line: 136,
            column: 25
          },
          end: {
            line: 142,
            column: 3
          }
        },
        line: 136
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 139,
            column: 29
          },
          end: {
            line: 139,
            column: 30
          }
        },
        loc: {
          start: {
            line: 139,
            column: 34
          },
          end: {
            line: 139,
            column: 90
          }
        },
        line: 139
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 144,
            column: 2
          },
          end: {
            line: 144,
            column: 3
          }
        },
        loc: {
          start: {
            line: 150,
            column: 4
          },
          end: {
            line: 256,
            column: 3
          }
        },
        line: 150
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 155,
            column: 14
          },
          end: {
            line: 155,
            column: 15
          }
        },
        loc: {
          start: {
            line: 155,
            column: 23
          },
          end: {
            line: 162,
            column: 9
          }
        },
        line: 155
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 156,
            column: 41
          },
          end: {
            line: 156,
            column: 42
          }
        },
        loc: {
          start: {
            line: 156,
            column: 71
          },
          end: {
            line: 156,
            column: 84
          }
        },
        line: 156
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 163,
            column: 8
          },
          end: {
            line: 163,
            column: 9
          }
        },
        loc: {
          start: {
            line: 163,
            column: 14
          },
          end: {
            line: 171,
            column: 9
          }
        },
        line: 163
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 165,
            column: 20
          },
          end: {
            line: 165,
            column: 21
          }
        },
        loc: {
          start: {
            line: 165,
            column: 25
          },
          end: {
            line: 165,
            column: 46
          }
        },
        line: 165
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 166,
            column: 17
          },
          end: {
            line: 166,
            column: 18
          }
        },
        loc: {
          start: {
            line: 166,
            column: 23
          },
          end: {
            line: 166,
            column: 90
          }
        },
        line: 166
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 177,
            column: 14
          },
          end: {
            line: 177,
            column: 15
          }
        },
        loc: {
          start: {
            line: 177,
            column: 52
          },
          end: {
            line: 237,
            column: 9
          }
        },
        line: 177
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 178,
            column: 62
          },
          end: {
            line: 178,
            column: 63
          }
        },
        loc: {
          start: {
            line: 178,
            column: 68
          },
          end: {
            line: 184,
            column: 11
          }
        },
        line: 178
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 185,
            column: 41
          },
          end: {
            line: 185,
            column: 42
          }
        },
        loc: {
          start: {
            line: 185,
            column: 46
          },
          end: {
            line: 185,
            column: 59
          }
        },
        line: 185
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 194,
            column: 37
          },
          end: {
            line: 194,
            column: 38
          }
        },
        loc: {
          start: {
            line: 194,
            column: 42
          },
          end: {
            line: 194,
            column: 55
          }
        },
        line: 194
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 197,
            column: 29
          },
          end: {
            line: 197,
            column: 30
          }
        },
        loc: {
          start: {
            line: 197,
            column: 34
          },
          end: {
            line: 197,
            column: 55
          }
        },
        line: 197
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 204,
            column: 31
          },
          end: {
            line: 204,
            column: 32
          }
        },
        loc: {
          start: {
            line: 204,
            column: 36
          },
          end: {
            line: 204,
            column: 57
          }
        },
        line: 204
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 227,
            column: 30
          },
          end: {
            line: 227,
            column: 31
          }
        },
        loc: {
          start: {
            line: 227,
            column: 40
          },
          end: {
            line: 231,
            column: 13
          }
        },
        line: 227
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 234,
            column: 29
          },
          end: {
            line: 234,
            column: 30
          }
        },
        loc: {
          start: {
            line: 234,
            column: 34
          },
          end: {
            line: 234,
            column: 55
          }
        },
        line: 234
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 243,
            column: 14
          },
          end: {
            line: 243,
            column: 15
          }
        },
        loc: {
          start: {
            line: 243,
            column: 23
          },
          end: {
            line: 253,
            column: 9
          }
        },
        line: 243
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 258,
            column: 2
          },
          end: {
            line: 258,
            column: 3
          }
        },
        loc: {
          start: {
            line: 258,
            column: 11
          },
          end: {
            line: 302,
            column: 3
          }
        },
        line: 258
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 266,
            column: 14
          },
          end: {
            line: 266,
            column: 15
          }
        },
        loc: {
          start: {
            line: 266,
            column: 19
          },
          end: {
            line: 266,
            column: 29
          }
        },
        line: 266
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 267,
            column: 15
          },
          end: {
            line: 267,
            column: 16
          }
        },
        loc: {
          start: {
            line: 267,
            column: 20
          },
          end: {
            line: 269,
            column: 7
          }
        },
        line: 267
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 268,
            column: 39
          },
          end: {
            line: 268,
            column: 40
          }
        },
        loc: {
          start: {
            line: 268,
            column: 62
          },
          end: {
            line: 268,
            column: 81
          }
        },
        line: 268
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 49
          }
        }, {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 49
          }
        }],
        line: 57
      },
      "1": {
        loc: {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 59,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 59,
            column: 42
          }
        }, {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 59,
            column: 42
          }
        }],
        line: 59
      },
      "2": {
        loc: {
          start: {
            line: 63,
            column: 13
          },
          end: {
            line: 63,
            column: 70
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 63,
            column: 68
          },
          end: {
            line: 63,
            column: 70
          }
        }],
        line: 63
      },
      "3": {
        loc: {
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 66,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 66,
            column: 5
          }
        }, {
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 66,
            column: 5
          }
        }],
        line: 64
      },
      "4": {
        loc: {
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 74,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 74,
            column: 38
          }
        }, {
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 74,
            column: 38
          }
        }],
        line: 74
      },
      "5": {
        loc: {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 75,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 75,
            column: 53
          }
        }, {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 75,
            column: 53
          }
        }],
        line: 75
      },
      "6": {
        loc: {
          start: {
            line: 75,
            column: 10
          },
          end: {
            line: 75,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 10
          },
          end: {
            line: 75,
            column: 29
          }
        }, {
          start: {
            line: 75,
            column: 33
          },
          end: {
            line: 75,
            column: 42
          }
        }],
        line: 75
      },
      "7": {
        loc: {
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 81,
            column: 50
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 81,
            column: 50
          }
        }, {
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 81,
            column: 50
          }
        }],
        line: 81
      },
      "8": {
        loc: {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 82,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 82,
            column: 43
          }
        }, {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 82,
            column: 43
          }
        }],
        line: 82
      },
      "9": {
        loc: {
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 83,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 83,
            column: 46
          }
        }, {
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 83,
            column: 46
          }
        }],
        line: 83
      },
      "10": {
        loc: {
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 84,
            column: 58
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 84,
            column: 58
          }
        }, {
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 84,
            column: 58
          }
        }],
        line: 84
      },
      "11": {
        loc: {
          start: {
            line: 84,
            column: 12
          },
          end: {
            line: 84,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 84,
            column: 12
          },
          end: {
            line: 84,
            column: 22
          }
        }, {
          start: {
            line: 84,
            column: 26
          },
          end: {
            line: 84,
            column: 35
          }
        }],
        line: 84
      },
      "12": {
        loc: {
          start: {
            line: 85,
            column: 8
          },
          end: {
            line: 85,
            column: 48
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 8
          },
          end: {
            line: 85,
            column: 48
          }
        }, {
          start: {
            line: 85,
            column: 8
          },
          end: {
            line: 85,
            column: 48
          }
        }],
        line: 85
      },
      "13": {
        loc: {
          start: {
            line: 86,
            column: 8
          },
          end: {
            line: 89,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 86,
            column: 8
          },
          end: {
            line: 89,
            column: 9
          }
        }, {
          start: {
            line: 86,
            column: 8
          },
          end: {
            line: 89,
            column: 9
          }
        }],
        line: 86
      },
      "14": {
        loc: {
          start: {
            line: 87,
            column: 10
          },
          end: {
            line: 87,
            column: 78
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 87,
            column: 10
          },
          end: {
            line: 87,
            column: 78
          }
        }, {
          start: {
            line: 87,
            column: 10
          },
          end: {
            line: 87,
            column: 78
          }
        }],
        line: 87
      },
      "15": {
        loc: {
          start: {
            line: 87,
            column: 14
          },
          end: {
            line: 87,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 87,
            column: 14
          },
          end: {
            line: 87,
            column: 32
          }
        }, {
          start: {
            line: 87,
            column: 36
          },
          end: {
            line: 87,
            column: 51
          }
        }],
        line: 87
      },
      "16": {
        loc: {
          start: {
            line: 88,
            column: 10
          },
          end: {
            line: 88,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 10
          },
          end: {
            line: 88,
            column: 56
          }
        }, {
          start: {
            line: 88,
            column: 10
          },
          end: {
            line: 88,
            column: 56
          }
        }],
        line: 88
      },
      "17": {
        loc: {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 99,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 99,
            column: 5
          }
        }, {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 99,
            column: 5
          }
        }],
        line: 93
      },
      "18": {
        loc: {
          start: {
            line: 93,
            column: 37
          },
          end: {
            line: 93,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 93,
            column: 37
          },
          end: {
            line: 93,
            column: 65
          }
        }, {
          start: {
            line: 93,
            column: 69
          },
          end: {
            line: 93,
            column: 83
          }
        }],
        line: 93
      },
      "19": {
        loc: {
          start: {
            line: 96,
            column: 10
          },
          end: {
            line: 96,
            column: 95
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 96,
            column: 10
          },
          end: {
            line: 96,
            column: 95
          }
        }, {
          start: {
            line: 96,
            column: 10
          },
          end: {
            line: 96,
            column: 95
          }
        }],
        line: 96
      },
      "20": {
        loc: {
          start: {
            line: 96,
            column: 14
          },
          end: {
            line: 96,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 96,
            column: 14
          },
          end: {
            line: 96,
            column: 46
          }
        }, {
          start: {
            line: 96,
            column: 50
          },
          end: {
            line: 96,
            column: 68
          }
        }],
        line: 96
      },
      "21": {
        loc: {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 110,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 110,
            column: 5
          }
        }, {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 110,
            column: 5
          }
        }],
        line: 102
      },
      "22": {
        loc: {
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 102,
            column: 117
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 102,
            column: 9
          },
          end: {
            line: 102,
            column: 20
          }
        }, {
          start: {
            line: 102,
            column: 24
          },
          end: {
            line: 102,
            column: 29
          }
        }, {
          start: {
            line: 102,
            column: 34
          },
          end: {
            line: 102,
            column: 55
          }
        }, {
          start: {
            line: 102,
            column: 59
          },
          end: {
            line: 102,
            column: 100
          }
        }, {
          start: {
            line: 102,
            column: 104
          },
          end: {
            line: 102,
            column: 117
          }
        }],
        line: 102
      },
      "23": {
        loc: {
          start: {
            line: 108,
            column: 15
          },
          end: {
            line: 108,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 108,
            column: 27
          },
          end: {
            line: 108,
            column: 33
          }
        }, {
          start: {
            line: 108,
            column: 36
          },
          end: {
            line: 108,
            column: 45
          }
        }],
        line: 108
      },
      "24": {
        loc: {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 126,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 126,
            column: 5
          }
        }, {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 126,
            column: 5
          }
        }],
        line: 119
      },
      "25": {
        loc: {
          start: {
            line: 122,
            column: 21
          },
          end: {
            line: 122,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 122,
            column: 21
          },
          end: {
            line: 122,
            column: 48
          }
        }, {
          start: {
            line: 122,
            column: 52
          },
          end: {
            line: 122,
            column: 54
          }
        }],
        line: 122
      },
      "26": {
        loc: {
          start: {
            line: 123,
            column: 21
          },
          end: {
            line: 123,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 123,
            column: 21
          },
          end: {
            line: 123,
            column: 48
          }
        }, {
          start: {
            line: 123,
            column: 52
          },
          end: {
            line: 123,
            column: 54
          }
        }],
        line: 123
      },
      "27": {
        loc: {
          start: {
            line: 124,
            column: 15
          },
          end: {
            line: 124,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 124,
            column: 33
          },
          end: {
            line: 124,
            column: 53
          }
        }, {
          start: {
            line: 124,
            column: 56
          },
          end: {
            line: 124,
            column: 76
          }
        }],
        line: 124
      },
      "28": {
        loc: {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 132,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 132,
            column: 32
          }
        }, {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 132,
            column: 32
          }
        }],
        line: 132
      },
      "29": {
        loc: {
          start: {
            line: 133,
            column: 33
          },
          end: {
            line: 133,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 133,
            column: 33
          },
          end: {
            line: 133,
            column: 79
          }
        }, {
          start: {
            line: 133,
            column: 83
          },
          end: {
            line: 133,
            column: 89
          }
        }],
        line: 133
      },
      "30": {
        loc: {
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 138,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 138,
            column: 34
          }
        }, {
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 138,
            column: 34
          }
        }],
        line: 138
      },
      "31": {
        loc: {
          start: {
            line: 139,
            column: 34
          },
          end: {
            line: 139,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 139,
            column: 34
          },
          end: {
            line: 139,
            column: 80
          }
        }, {
          start: {
            line: 139,
            column: 84
          },
          end: {
            line: 139,
            column: 90
          }
        }],
        line: 139
      },
      "32": {
        loc: {
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 140,
            column: 50
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 140,
            column: 50
          }
        }, {
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 140,
            column: 50
          }
        }],
        line: 140
      },
      "33": {
        loc: {
          start: {
            line: 140,
            column: 8
          },
          end: {
            line: 140,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 140,
            column: 8
          },
          end: {
            line: 140,
            column: 11
          }
        }, {
          start: {
            line: 140,
            column: 15
          },
          end: {
            line: 140,
            column: 38
          }
        }],
        line: 140
      },
      "34": {
        loc: {
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 174,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 174,
            column: 5
          }
        }, {
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 174,
            column: 5
          }
        }],
        line: 153
      },
      "35": {
        loc: {
          start: {
            line: 157,
            column: 10
          },
          end: {
            line: 161,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 157,
            column: 10
          },
          end: {
            line: 161,
            column: 11
          }
        }, {
          start: {
            line: 157,
            column: 10
          },
          end: {
            line: 161,
            column: 11
          }
        }],
        line: 157
      },
      "36": {
        loc: {
          start: {
            line: 165,
            column: 25
          },
          end: {
            line: 165,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 165,
            column: 25
          },
          end: {
            line: 165,
            column: 32
          }
        }, {
          start: {
            line: 165,
            column: 36
          },
          end: {
            line: 165,
            column: 46
          }
        }],
        line: 165
      },
      "37": {
        loc: {
          start: {
            line: 167,
            column: 10
          },
          end: {
            line: 169,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 167,
            column: 10
          },
          end: {
            line: 169,
            column: 11
          }
        }, {
          start: {
            line: 167,
            column: 10
          },
          end: {
            line: 169,
            column: 11
          }
        }],
        line: 167
      },
      "38": {
        loc: {
          start: {
            line: 167,
            column: 14
          },
          end: {
            line: 167,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 167,
            column: 14
          },
          end: {
            line: 167,
            column: 40
          }
        }, {
          start: {
            line: 167,
            column: 44
          },
          end: {
            line: 167,
            column: 77
          }
        }],
        line: 167
      },
      "39": {
        loc: {
          start: {
            line: 170,
            column: 10
          },
          end: {
            line: 170,
            column: 71
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 170,
            column: 10
          },
          end: {
            line: 170,
            column: 71
          }
        }, {
          start: {
            line: 170,
            column: 10
          },
          end: {
            line: 170,
            column: 71
          }
        }],
        line: 170
      },
      "40": {
        loc: {
          start: {
            line: 175,
            column: 4
          },
          end: {
            line: 255,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 175,
            column: 4
          },
          end: {
            line: 255,
            column: 5
          }
        }, {
          start: {
            line: 175,
            column: 4
          },
          end: {
            line: 255,
            column: 5
          }
        }],
        line: 175
      },
      "41": {
        loc: {
          start: {
            line: 186,
            column: 10
          },
          end: {
            line: 189,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 186,
            column: 10
          },
          end: {
            line: 189,
            column: 11
          }
        }, {
          start: {
            line: 186,
            column: 10
          },
          end: {
            line: 189,
            column: 11
          }
        }],
        line: 186
      },
      "42": {
        loc: {
          start: {
            line: 186,
            column: 14
          },
          end: {
            line: 186,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 186,
            column: 14
          },
          end: {
            line: 186,
            column: 39
          }
        }, {
          start: {
            line: 186,
            column: 43
          },
          end: {
            line: 186,
            column: 68
          }
        }],
        line: 186
      },
      "43": {
        loc: {
          start: {
            line: 190,
            column: 10
          },
          end: {
            line: 232,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 190,
            column: 10
          },
          end: {
            line: 232,
            column: 11
          }
        }, {
          start: {
            line: 190,
            column: 10
          },
          end: {
            line: 232,
            column: 11
          }
        }],
        line: 190
      },
      "44": {
        loc: {
          start: {
            line: 197,
            column: 34
          },
          end: {
            line: 197,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 197,
            column: 34
          },
          end: {
            line: 197,
            column: 41
          }
        }, {
          start: {
            line: 197,
            column: 45
          },
          end: {
            line: 197,
            column: 55
          }
        }],
        line: 197
      },
      "45": {
        loc: {
          start: {
            line: 198,
            column: 25
          },
          end: {
            line: 198,
            column: 117
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 198,
            column: 59
          },
          end: {
            line: 198,
            column: 105
          }
        }, {
          start: {
            line: 198,
            column: 108
          },
          end: {
            line: 198,
            column: 117
          }
        }],
        line: 198
      },
      "46": {
        loc: {
          start: {
            line: 201,
            column: 12
          },
          end: {
            line: 205,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 201,
            column: 12
          },
          end: {
            line: 205,
            column: 13
          }
        }, {
          start: {
            line: 201,
            column: 12
          },
          end: {
            line: 205,
            column: 13
          }
        }],
        line: 201
      },
      "47": {
        loc: {
          start: {
            line: 204,
            column: 36
          },
          end: {
            line: 204,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 204,
            column: 36
          },
          end: {
            line: 204,
            column: 43
          }
        }, {
          start: {
            line: 204,
            column: 47
          },
          end: {
            line: 204,
            column: 57
          }
        }],
        line: 204
      },
      "48": {
        loc: {
          start: {
            line: 206,
            column: 12
          },
          end: {
            line: 216,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 206,
            column: 12
          },
          end: {
            line: 216,
            column: 13
          }
        }, {
          start: {
            line: 206,
            column: 12
          },
          end: {
            line: 216,
            column: 13
          }
        }],
        line: 206
      },
      "49": {
        loc: {
          start: {
            line: 217,
            column: 25
          },
          end: {
            line: 217,
            column: 117
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 217,
            column: 59
          },
          end: {
            line: 217,
            column: 105
          }
        }, {
          start: {
            line: 217,
            column: 108
          },
          end: {
            line: 217,
            column: 117
          }
        }],
        line: 217
      },
      "50": {
        loc: {
          start: {
            line: 228,
            column: 26
          },
          end: {
            line: 228,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 228,
            column: 26
          },
          end: {
            line: 228,
            column: 34
          }
        }, {
          start: {
            line: 228,
            column: 38
          },
          end: {
            line: 228,
            column: 39
          }
        }],
        line: 228
      },
      "51": {
        loc: {
          start: {
            line: 229,
            column: 26
          },
          end: {
            line: 229,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 229,
            column: 26
          },
          end: {
            line: 229,
            column: 34
          }
        }, {
          start: {
            line: 229,
            column: 38
          },
          end: {
            line: 229,
            column: 39
          }
        }],
        line: 229
      },
      "52": {
        loc: {
          start: {
            line: 233,
            column: 10
          },
          end: {
            line: 236,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 233,
            column: 10
          },
          end: {
            line: 236,
            column: 11
          }
        }, {
          start: {
            line: 233,
            column: 10
          },
          end: {
            line: 236,
            column: 11
          }
        }],
        line: 233
      },
      "53": {
        loc: {
          start: {
            line: 234,
            column: 34
          },
          end: {
            line: 234,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 234,
            column: 34
          },
          end: {
            line: 234,
            column: 41
          }
        }, {
          start: {
            line: 234,
            column: 45
          },
          end: {
            line: 234,
            column: 55
          }
        }],
        line: 234
      },
      "54": {
        loc: {
          start: {
            line: 241,
            column: 8
          },
          end: {
            line: 241,
            column: 115
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 241,
            column: 37
          },
          end: {
            line: 241,
            column: 99
          }
        }, {
          start: {
            line: 241,
            column: 102
          },
          end: {
            line: 241,
            column: 115
          }
        }],
        line: 241
      },
      "55": {
        loc: {
          start: {
            line: 262,
            column: 4
          },
          end: {
            line: 262,
            column: 89
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 262,
            column: 4
          },
          end: {
            line: 262,
            column: 89
          }
        }, {
          start: {
            line: 262,
            column: 4
          },
          end: {
            line: 262,
            column: 89
          }
        }],
        line: 262
      },
      "56": {
        loc: {
          start: {
            line: 268,
            column: 8
          },
          end: {
            line: 268,
            column: 82
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 268,
            column: 8
          },
          end: {
            line: 268,
            column: 82
          }
        }, {
          start: {
            line: 268,
            column: 8
          },
          end: {
            line: 268,
            column: 82
          }
        }],
        line: 268
      },
      "57": {
        loc: {
          start: {
            line: 273,
            column: 4
          },
          end: {
            line: 279,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 273,
            column: 4
          },
          end: {
            line: 279,
            column: 5
          }
        }, {
          start: {
            line: 273,
            column: 4
          },
          end: {
            line: 279,
            column: 5
          }
        }],
        line: 273
      },
      "58": {
        loc: {
          start: {
            line: 273,
            column: 8
          },
          end: {
            line: 273,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 273,
            column: 8
          },
          end: {
            line: 273,
            column: 24
          }
        }, {
          start: {
            line: 273,
            column: 28
          },
          end: {
            line: 273,
            column: 43
          }
        }],
        line: 273
      },
      "59": {
        loc: {
          start: {
            line: 275,
            column: 11
          },
          end: {
            line: 279,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 275,
            column: 11
          },
          end: {
            line: 279,
            column: 5
          }
        }, {
          start: {
            line: 275,
            column: 11
          },
          end: {
            line: 279,
            column: 5
          }
        }],
        line: 275
      },
      "60": {
        loc: {
          start: {
            line: 277,
            column: 11
          },
          end: {
            line: 279,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 277,
            column: 11
          },
          end: {
            line: 279,
            column: 5
          }
        }, {
          start: {
            line: 277,
            column: 11
          },
          end: {
            line: 279,
            column: 5
          }
        }],
        line: 277
      },
      "61": {
        loc: {
          start: {
            line: 281,
            column: 34
          },
          end: {
            line: 281,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 281,
            column: 34
          },
          end: {
            line: 281,
            column: 61
          }
        }, {
          start: {
            line: 281,
            column: 65
          },
          end: {
            line: 281,
            column: 67
          }
        }],
        line: 281
      },
      "62": {
        loc: {
          start: {
            line: 285,
            column: 35
          },
          end: {
            line: 285,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 285,
            column: 35
          },
          end: {
            line: 285,
            column: 62
          }
        }, {
          start: {
            line: 285,
            column: 66
          },
          end: {
            line: 285,
            column: 68
          }
        }],
        line: 285
      },
      "63": {
        loc: {
          start: {
            line: 298,
            column: 30
          },
          end: {
            line: 298,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 298,
            column: 61
          },
          end: {
            line: 298,
            column: 81
          }
        }, {
          start: {
            line: 298,
            column: 84
          },
          end: {
            line: 298,
            column: 93
          }
        }],
        line: 298
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0, 0, 0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0, 0],
      "58": [0, 0],
      "59": [0, 0],
      "60": [0, 0],
      "61": [0, 0],
      "62": [0, 0],
      "63": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/index.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
import deepEqual from 'deep-eql';
import pagable from '../hoc/pagable';
import Table from './Table';
import { compose } from '../utils/func';
import { isFunc } from '../utils/is';
import treeExpand from './TreeExpand';
var TableWithPagination = (cov_20tzfergng.s[0]++, pagable(Table));
var TableWithTree = (cov_20tzfergng.s[1]++, treeExpand(Table));
var TableWithPT = (cov_20tzfergng.s[2]++, compose(pagable, treeExpand)(Table));

var TableIndex =
/*#__PURE__*/
function (_ref) {
  _inherits(TableIndex, _ref);

  var _super = _createSuper2(TableIndex);

  function TableIndex(props) {
    var _this;

    _classCallCheck(this, TableIndex);

    cov_20tzfergng.f[0]++;
    cov_20tzfergng.s[3]++;
    _this = _super.call(this, props);
    _this.cacheDefaultSorterList = void 0;
    _this.oldColumns = void 0;
    _this.cachedColumns = void 0;
    cov_20tzfergng.s[4]++;
    _this.state = {
      sorter: []
    };
    cov_20tzfergng.s[5]++;
    _this.handleSortChange = _this.handleSortChange.bind(_assertThisInitialized(_this));
    cov_20tzfergng.s[6]++;
    _this.cacheDefaultSorterList = [];
    return _this;
  }

  _createClass(TableIndex, [{
    key: "getTreeColumnsName",
    value: function getTreeColumnsName() {
      cov_20tzfergng.f[1]++;
      var columns = (cov_20tzfergng.s[7]++, this.getFilteredColumn());
      cov_20tzfergng.s[8]++;

      if (!Array.isArray(columns)) {
        cov_20tzfergng.b[0][0]++;
        cov_20tzfergng.s[9]++;
        return undefined;
      } else {
        cov_20tzfergng.b[0][1]++;
      }

      var has = (cov_20tzfergng.s[10]++, columns.filter(function (v) {
        cov_20tzfergng.f[2]++;
        cov_20tzfergng.s[11]++;
        return typeof v.treeColumnsName === 'string';
      }));
      cov_20tzfergng.s[12]++;

      if (has.length === 0) {
        cov_20tzfergng.b[1][0]++;
        cov_20tzfergng.s[13]++;
        return undefined;
      } else {
        cov_20tzfergng.b[1][1]++;
      }

      cov_20tzfergng.s[14]++;
      return has[0].treeColumnsName;
    }
  }, {
    key: "getColumns",
    value: function getColumns() {
      var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_20tzfergng.b[2][0]++, []);
      cov_20tzfergng.f[3]++;
      cov_20tzfergng.s[15]++;

      if (deepEqual(columns, this.oldColumns)) {
        cov_20tzfergng.b[3][0]++;
        cov_20tzfergng.s[16]++;
        return this.cachedColumns;
      } else {
        cov_20tzfergng.b[3][1]++;
      }

      var _ref2 = (cov_20tzfergng.s[17]++, this.props),
          onRowSelect = _ref2.onRowSelect,
          datum = _ref2.datum;

      cov_20tzfergng.s[18]++;
      columns = columns.filter(function (c) {
        cov_20tzfergng.f[4]++;
        cov_20tzfergng.s[19]++;
        return typeof c === 'object';
      });
      var left = (cov_20tzfergng.s[20]++, -1);
      var right = (cov_20tzfergng.s[21]++, -1);
      cov_20tzfergng.s[22]++;
      columns.forEach(function (c, i) {
        cov_20tzfergng.f[5]++;
        cov_20tzfergng.s[23]++;

        if (c.fixed === 'left') {
          cov_20tzfergng.b[4][0]++;
          cov_20tzfergng.s[24]++;
          left = i;
        } else {
          cov_20tzfergng.b[4][1]++;
        }

        cov_20tzfergng.s[25]++;

        if ((cov_20tzfergng.b[6][0]++, c.fixed === 'right') && (cov_20tzfergng.b[6][1]++, right < 0)) {
          cov_20tzfergng.b[5][0]++;
          cov_20tzfergng.s[26]++;
          right = i;
        } else {
          cov_20tzfergng.b[5][1]++;
        }
      });
      var setDefaultOrder = (cov_20tzfergng.s[27]++, false);
      cov_20tzfergng.s[28]++;
      this.cachedColumns = columns.map(function (c, i) {
        cov_20tzfergng.f[6]++;
        cov_20tzfergng.s[29]++;
        return immer(c, function (draft) {
          cov_20tzfergng.f[7]++;
          cov_20tzfergng.s[30]++;
          draft.index = i;
          cov_20tzfergng.s[31]++;

          if (draft.key === undefined) {
            cov_20tzfergng.b[7][0]++;
            cov_20tzfergng.s[32]++;
            draft.key = i;
          } else {
            cov_20tzfergng.b[7][1]++;
          }

          cov_20tzfergng.s[33]++;

          if (i <= left) {
            cov_20tzfergng.b[8][0]++;
            cov_20tzfergng.s[34]++;
            draft.fixed = 'left';
          } else {
            cov_20tzfergng.b[8][1]++;
          }

          cov_20tzfergng.s[35]++;

          if (i === left) {
            cov_20tzfergng.b[9][0]++;
            cov_20tzfergng.s[36]++;
            draft.lastFixed = true;
          } else {
            cov_20tzfergng.b[9][1]++;
          }

          cov_20tzfergng.s[37]++;

          if ((cov_20tzfergng.b[11][0]++, i >= right) && (cov_20tzfergng.b[11][1]++, right > 0)) {
            cov_20tzfergng.b[10][0]++;
            cov_20tzfergng.s[38]++;
            draft.fixed = 'right';
          } else {
            cov_20tzfergng.b[10][1]++;
          }

          cov_20tzfergng.s[39]++;

          if (i === right) {
            cov_20tzfergng.b[12][0]++;
            cov_20tzfergng.s[40]++;
            draft.firstFixed = true;
          } else {
            cov_20tzfergng.b[12][1]++;
          }

          cov_20tzfergng.s[41]++;

          if (typeof draft.sorter !== 'object') {
            cov_20tzfergng.b[13][0]++;
            cov_20tzfergng.s[42]++;

            if ((cov_20tzfergng.b[15][0]++, draft.defaultOrder) && (cov_20tzfergng.b[15][1]++, setDefaultOrder)) {
              cov_20tzfergng.b[14][0]++;
              cov_20tzfergng.s[43]++;
              delete draft.defaultOrder;
            } else {
              cov_20tzfergng.b[14][1]++;
            }

            cov_20tzfergng.s[44]++;

            if (draft.defaultOrder) {
              cov_20tzfergng.b[16][0]++;
              cov_20tzfergng.s[45]++;
              setDefaultOrder = true;
            } else {
              cov_20tzfergng.b[16][1]++;
            }
          } else {
            cov_20tzfergng.b[13][1]++;
          } // if (draft.type === 'expand' && !draft.width) draft.width = 48

        });
      });
      cov_20tzfergng.s[46]++;

      if (this.cachedColumns.find(function (v) {
        cov_20tzfergng.f[8]++;
        cov_20tzfergng.s[47]++;
        return (cov_20tzfergng.b[18][0]++, typeof v.sorter !== 'object') && (cov_20tzfergng.b[18][1]++, v.defaultOrder);
      })) {
        cov_20tzfergng.b[17][0]++;
        cov_20tzfergng.s[48]++;
        this.cachedColumns = this.cachedColumns.map(function (v) {
          cov_20tzfergng.f[9]++;
          cov_20tzfergng.s[49]++;
          return immer(v, function (draft) {
            cov_20tzfergng.f[10]++;
            cov_20tzfergng.s[50]++;

            if ((cov_20tzfergng.b[20][0]++, typeof draft.sorter === 'object') && (cov_20tzfergng.b[20][1]++, draft.defaultOrder)) {
              cov_20tzfergng.b[19][0]++;
              cov_20tzfergng.s[51]++;
              delete draft.defaultOrder;
            } else {
              cov_20tzfergng.b[19][1]++;
            }
          });
        });
      } else {
        cov_20tzfergng.b[17][1]++;
      } // filter checkbox


      var haveCheckbox = (cov_20tzfergng.s[52]++, columns.find(function (v) {
        cov_20tzfergng.f[11]++;
        cov_20tzfergng.s[53]++;
        return v.type === 'checkbox';
      }));
      cov_20tzfergng.s[54]++;

      if (((cov_20tzfergng.b[22][0]++, onRowSelect) || (cov_20tzfergng.b[22][1]++, datum)) && (cov_20tzfergng.b[22][2]++, this.cachedColumns[0]) && (cov_20tzfergng.b[22][3]++, this.cachedColumns[0].type !== 'checkbox') && (cov_20tzfergng.b[22][4]++, !haveCheckbox)) {
        cov_20tzfergng.b[21][0]++;
        cov_20tzfergng.s[55]++;
        this.cachedColumns.unshift({
          index: -1,
          key: 'checkbox',
          type: 'checkbox',
          // width: 48,
          fixed: left >= 0 ? (cov_20tzfergng.b[23][0]++, 'left') : (cov_20tzfergng.b[23][1]++, undefined)
        });
      } else {
        cov_20tzfergng.b[21][1]++;
      }

      cov_20tzfergng.s[56]++;
      this.oldColumns = columns;
      cov_20tzfergng.s[57]++;
      return this.cachedColumns;
    }
  }, {
    key: "getTableSorter",
    value: function getTableSorter() {
      cov_20tzfergng.f[12]++;

      var _ref3 = (cov_20tzfergng.s[58]++, this.props),
          tableSorter = _ref3.sorter;

      cov_20tzfergng.s[59]++;

      if (!tableSorter) {
        cov_20tzfergng.b[24][0]++;
        cov_20tzfergng.s[60]++;
        console.error('You need to specify a sorter as a sort function for the table. Default alphabetical order.');
        cov_20tzfergng.s[61]++;

        tableSorter = function tableSorter(sorter, order) {
          cov_20tzfergng.f[13]++;
          cov_20tzfergng.s[62]++;
          return function (a, b) {
            cov_20tzfergng.f[14]++;
            var a1 = (cov_20tzfergng.s[63]++, ((cov_20tzfergng.b[25][0]++, a[sorter]) || (cov_20tzfergng.b[25][1]++, '')).toString());
            var b1 = (cov_20tzfergng.s[64]++, ((cov_20tzfergng.b[26][0]++, b[sorter]) || (cov_20tzfergng.b[26][1]++, '')).toString());
            cov_20tzfergng.s[65]++;
            return order === 'asc' ? (cov_20tzfergng.b[27][0]++, a1.localeCompare(b1)) : (cov_20tzfergng.b[27][1]++, b1.localeCompare(a1));
          };
        };
      } else {
        cov_20tzfergng.b[24][1]++;
      }

      cov_20tzfergng.s[66]++;
      return tableSorter;
    }
  }, {
    key: "getFilteredColumn",
    value: function getFilteredColumn() {
      cov_20tzfergng.f[15]++;

      var _ref4 = (cov_20tzfergng.s[67]++, this.props),
          columns = _ref4.columns;

      cov_20tzfergng.s[68]++;

      if (!columns) {
        cov_20tzfergng.b[28][0]++;
        cov_20tzfergng.s[69]++;
        return columns;
      } else {
        cov_20tzfergng.b[28][1]++;
      }

      cov_20tzfergng.s[70]++;
      return columns.filter(function (v) {
        cov_20tzfergng.f[16]++;
        cov_20tzfergng.s[71]++;
        return !((cov_20tzfergng.b[29][0]++, ['expand', 'row-expand'].indexOf(v.type) > -1) && (cov_20tzfergng.b[29][1]++, v.hide));
      });
    }
  }, {
    key: "getExternalExpandObj",
    value: function getExternalExpandObj() {
      cov_20tzfergng.f[17]++;

      var _ref5 = (cov_20tzfergng.s[72]++, this.props),
          columns = _ref5.columns;

      cov_20tzfergng.s[73]++;

      if (!columns) {
        cov_20tzfergng.b[30][0]++;
        cov_20tzfergng.s[74]++;
        return undefined;
      } else {
        cov_20tzfergng.b[30][1]++;
      }

      var obj = (cov_20tzfergng.s[75]++, columns.find(function (v) {
        cov_20tzfergng.f[18]++;
        cov_20tzfergng.s[76]++;
        return (cov_20tzfergng.b[31][0]++, ['expand', 'row-expand'].indexOf(v.type) > -1) && (cov_20tzfergng.b[31][1]++, v.hide);
      }));
      cov_20tzfergng.s[77]++;

      if ((cov_20tzfergng.b[33][0]++, obj) && (cov_20tzfergng.b[33][1]++, typeof obj === 'object')) {
        cov_20tzfergng.b[32][0]++;
        cov_20tzfergng.s[78]++;
        return obj;
      } else {
        cov_20tzfergng.b[32][1]++;
      }

      cov_20tzfergng.s[79]++;
      return undefined;
    }
  }, {
    key: "handleSortChange",
    value: function handleSortChange(order, sorter, key, cancelOrder, manual) {
      var _this2 = this;

      cov_20tzfergng.f[19]++;

      var _ref6 = (cov_20tzfergng.s[80]++, this.props),
          onSortCancel = _ref6.onSortCancel; // cancel sorter


      cov_20tzfergng.s[81]++;

      if (!order) {
        cov_20tzfergng.b[34][0]++;
        cov_20tzfergng.s[82]++;
        this.setState(immer(function (state) {
          cov_20tzfergng.f[20]++;
          var item = (cov_20tzfergng.s[83]++, state.sorter.find(function (v) {
            cov_20tzfergng.f[21]++;
            cov_20tzfergng.s[84]++;
            return v.key === key;
          }));
          cov_20tzfergng.s[85]++;

          if (item) {
            cov_20tzfergng.b[35][0]++;
            cov_20tzfergng.s[86]++;
            item.order = undefined;
            cov_20tzfergng.s[87]++;
            item.manual = true;
            cov_20tzfergng.s[88]++;
            item.deleted = true;
          } else {
            cov_20tzfergng.b[35][1]++;
          }
        }), function () {
          cov_20tzfergng.f[22]++;
          var rpm = (cov_20tzfergng.s[89]++, _this2.state.sorter.filter(function (v) {
            cov_20tzfergng.f[23]++;
            cov_20tzfergng.s[90]++;
            return (cov_20tzfergng.b[36][0]++, v.order) && (cov_20tzfergng.b[36][1]++, !v.deleted);
          }).map(function (v) {
            cov_20tzfergng.f[24]++;
            cov_20tzfergng.s[91]++;
            return {
              order: v.order,
              key: v.key,
              weight: v.weight,
              manual: v.manual
            };
          }));
          cov_20tzfergng.s[92]++;

          if ((cov_20tzfergng.b[38][0]++, typeof sorter === 'object') && (cov_20tzfergng.b[38][1]++, typeof sorter.rule === 'function')) {
            cov_20tzfergng.b[37][0]++;
            cov_20tzfergng.s[93]++;
            sorter.rule(rpm);
          } else {
            cov_20tzfergng.b[37][1]++;
          }

          cov_20tzfergng.s[94]++;

          if (onSortCancel) {
            cov_20tzfergng.b[39][0]++;
            cov_20tzfergng.s[95]++;
            onSortCancel(cancelOrder, key, rpm, sorter);
          } else {
            cov_20tzfergng.b[39][1]++;
          }
        });
        cov_20tzfergng.s[96]++;
        return;
      } else {
        cov_20tzfergng.b[34][1]++;
      }

      cov_20tzfergng.s[97]++;

      if (typeof sorter === 'object') {
        cov_20tzfergng.b[40][0]++;
        cov_20tzfergng.s[98]++;
        this.setState(immer(function (state) {
          cov_20tzfergng.f[25]++;
          var rpm = (cov_20tzfergng.s[99]++, state.sorter.map(function (v) {
            cov_20tzfergng.f[26]++;
            cov_20tzfergng.s[100]++;
            return {
              order: v.order,
              key: v.key,
              weight: v.weight,
              manual: v.manual,
              deleted: v.deleted
            };
          }));
          var item = (cov_20tzfergng.s[101]++, state.sorter.find(function (v) {
            cov_20tzfergng.f[27]++;
            cov_20tzfergng.s[102]++;
            return v.key === key;
          }));
          cov_20tzfergng.s[103]++;

          if ((cov_20tzfergng.b[42][0]++, state.sorter.length === 1) && (cov_20tzfergng.b[42][1]++, !state.sorter[0].multiple)) {
            cov_20tzfergng.b[41][0]++;
            cov_20tzfergng.s[104]++;
            state.sorter = [];
            cov_20tzfergng.s[105]++;
            rpm = [];
          } else {
            cov_20tzfergng.b[41][1]++;
          }

          cov_20tzfergng.s[106]++;

          if (item) {
            cov_20tzfergng.b[43][0]++;
            cov_20tzfergng.s[107]++;
            item.order = order;
            cov_20tzfergng.s[108]++;
            item.manual = manual;
            cov_20tzfergng.s[109]++;
            item.deleted = false;
            var rpmItem = (cov_20tzfergng.s[110]++, rpm.find(function (v) {
              cov_20tzfergng.f[28]++;
              cov_20tzfergng.s[111]++;
              return v.key === key;
            }));
            cov_20tzfergng.s[112]++;
            rpmItem.order = order;
            cov_20tzfergng.s[113]++;
            rpmItem.manual = manual;
            cov_20tzfergng.s[114]++;
            rpm = rpm.filter(function (v) {
              cov_20tzfergng.f[29]++;
              cov_20tzfergng.s[115]++;
              return (cov_20tzfergng.b[44][0]++, v.order) && (cov_20tzfergng.b[44][1]++, !v.deleted);
            });
            var sort = (cov_20tzfergng.s[116]++, typeof sorter.rule === 'string' ? (cov_20tzfergng.b[45][0]++, _this2.getTableSorter()(sorter.rule, order, rpm)) : (cov_20tzfergng.b[45][1]++, undefined));
            cov_20tzfergng.s[117]++;
            item.sort = sort;
          } else {
            cov_20tzfergng.b[43][1]++;
            cov_20tzfergng.s[118]++;

            if (manual) {
              cov_20tzfergng.b[46][0]++;
              cov_20tzfergng.s[119]++;
              _this2.cacheDefaultSorterList = [];
              cov_20tzfergng.s[120]++;
              rpm.push({
                order: order,
                key: key,
                weight: sorter.weight,
                manual: manual,
                deleted: false
              });
              cov_20tzfergng.s[121]++;
              rpm = rpm.filter(function (v) {
                cov_20tzfergng.f[30]++;
                cov_20tzfergng.s[122]++;
                return (cov_20tzfergng.b[47][0]++, v.order) && (cov_20tzfergng.b[47][1]++, !v.deleted);
              });
            } else {
              cov_20tzfergng.b[46][1]++;
            }

            cov_20tzfergng.s[123]++;

            if (!manual) {
              cov_20tzfergng.b[48][0]++;
              cov_20tzfergng.s[124]++;

              _this2.cacheDefaultSorterList.push({
                order: order,
                key: key,
                weight: sorter.weight,
                deleted: false,
                multiple: false,
                manual: manual
              });

              cov_20tzfergng.s[125]++;
              rpm = _this2.cacheDefaultSorterList;
            } else {
              cov_20tzfergng.b[48][1]++;
            }

            var _sort = (cov_20tzfergng.s[126]++, typeof sorter.rule === 'string' ? (cov_20tzfergng.b[49][0]++, _this2.getTableSorter()(sorter.rule, order, rpm)) : (cov_20tzfergng.b[49][1]++, undefined));

            cov_20tzfergng.s[127]++;
            state.sorter.push({
              order: order,
              key: key,
              sort: _sort,
              manual: manual,
              multiple: true,
              weight: sorter.weight,
              deleted: false
            });
            cov_20tzfergng.s[128]++;
            state.sorter.sort(function (a, b) {
              cov_20tzfergng.f[31]++;
              var a1 = (cov_20tzfergng.s[129]++, ((cov_20tzfergng.b[50][0]++, a.weight) || (cov_20tzfergng.b[50][1]++, 0)).toString());
              var b1 = (cov_20tzfergng.s[130]++, ((cov_20tzfergng.b[51][0]++, b.weight) || (cov_20tzfergng.b[51][1]++, 0)).toString());
              cov_20tzfergng.s[131]++;
              return a1.localeCompare(b1);
            });
          }

          cov_20tzfergng.s[132]++;

          if (typeof sorter.rule === 'function') {
            cov_20tzfergng.b[52][0]++;
            cov_20tzfergng.s[133]++;
            rpm = rpm.filter(function (v) {
              cov_20tzfergng.f[32]++;
              cov_20tzfergng.s[134]++;
              return (cov_20tzfergng.b[53][0]++, v.order) && (cov_20tzfergng.b[53][1]++, !v.deleted);
            });
            cov_20tzfergng.s[135]++;
            sorter.rule(rpm);
          } else {
            cov_20tzfergng.b[52][1]++;
          }
        }));
      } else {
        cov_20tzfergng.b[40][1]++;
        var sort = (cov_20tzfergng.s[136]++, typeof sorter === 'string' ? (cov_20tzfergng.b[54][0]++, this.getTableSorter()(sorter, order, [{
          order: order,
          key: key,
          manual: manual
        }])) : (cov_20tzfergng.b[54][1]++, sorter(order)));
        cov_20tzfergng.s[137]++;
        this.setState(immer(function (state) {
          cov_20tzfergng.f[33]++;
          cov_20tzfergng.s[138]++;
          state.sorter = [];
          cov_20tzfergng.s[139]++;
          state.sorter.push({
            order: order,
            key: key,
            sort: sort,
            manual: manual,
            multiple: false,
            deleted: false
          });
        }));
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_20tzfergng.f[34]++;

      var _ref7 = (cov_20tzfergng.s[140]++, this.props),
          onRowSelect = _ref7.onRowSelect,
          props = _objectWithoutProperties(_ref7, ["onRowSelect"]);

      var columns = (cov_20tzfergng.s[141]++, this.getFilteredColumn());

      var _ref8 = (cov_20tzfergng.s[142]++, this.state),
          sorter = _ref8.sorter;

      cov_20tzfergng.s[143]++;

      if (!columns) {
        cov_20tzfergng.b[55][0]++;
        cov_20tzfergng.s[144]++;
        return (
          /*#__PURE__*/
          React.createElement(Table, Object.assign({}, props, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 262,
              columnNumber: 26
            }
          }))
        );
      } else {
        cov_20tzfergng.b[55][1]++;
      }

      var _ref9 = (cov_20tzfergng.s[145]++, this.props),
          data = _ref9.data;

      cov_20tzfergng.s[146]++;
      sorter.filter(function (v) {
        cov_20tzfergng.f[35]++;
        cov_20tzfergng.s[147]++;
        return !v.deleted;
      }).forEach(function (v) {
        cov_20tzfergng.f[36]++;
        cov_20tzfergng.s[148]++;

        if (v.sort) {
          cov_20tzfergng.b[56][0]++;
          cov_20tzfergng.s[149]++;
          data = immer(data, function (draft) {
            cov_20tzfergng.f[37]++;
            cov_20tzfergng.s[150]++;
            return draft.sort(v.sort);
          });
        } else {
          cov_20tzfergng.b[56][1]++;
        }
      });
      var treeColumnsName = (cov_20tzfergng.s[151]++, this.getTreeColumnsName());
      var Component = (cov_20tzfergng.s[152]++, Table);
      cov_20tzfergng.s[153]++;

      if ((cov_20tzfergng.b[58][0]++, props.pagination) && (cov_20tzfergng.b[58][1]++, treeColumnsName)) {
        cov_20tzfergng.b[57][0]++;
        cov_20tzfergng.s[154]++;
        Component = TableWithPT;
      } else {
        cov_20tzfergng.b[57][1]++;
        cov_20tzfergng.s[155]++;

        if (props.pagination) {
          cov_20tzfergng.b[59][0]++;
          cov_20tzfergng.s[156]++;
          Component = TableWithPagination;
        } else {
          cov_20tzfergng.b[59][1]++;
          cov_20tzfergng.s[157]++;

          if (treeColumnsName) {
            cov_20tzfergng.b[60][0]++;
            cov_20tzfergng.s[158]++;
            Component = TableWithTree;
          } else {
            cov_20tzfergng.b[60][1]++;
          }
        }
      }

      var externalExpandRender = (cov_20tzfergng.s[159]++, ((cov_20tzfergng.b[61][0]++, this.getExternalExpandObj()) || (cov_20tzfergng.b[61][1]++, {})).render);
      var externalExpandOnClick = (cov_20tzfergng.s[160]++, ((cov_20tzfergng.b[62][0]++, this.getExternalExpandObj()) || (cov_20tzfergng.b[62][1]++, {})).onClick);
      var ComponentPT = (cov_20tzfergng.s[161]++, Component);
      cov_20tzfergng.s[162]++;
      return (
        /*#__PURE__*/
        React.createElement(ComponentPT, Object.assign({}, props, {
          onChange: onRowSelect,
          columns: this.getColumns(columns),
          data: data,
          sorter: sorter,
          onSortChange: this.handleSortChange,
          treeColumnsName: treeColumnsName,
          externalExpandRender: isFunc(externalExpandRender) ? (cov_20tzfergng.b[63][0]++, externalExpandRender) : (cov_20tzfergng.b[63][1]++, undefined),
          externalExpandClick: externalExpandOnClick,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 290,
            columnNumber: 7
          }
        }))
      );
    }
  }]);

  return TableIndex;
}((React.Component));

TableIndex.displayName = 'ShineoutTable';
TableIndex.defaultProps = {
  data: []
};
export { TableIndex as default };